import { useFormInput } from '@/hooks';
import { Toggle as BaseToggle, Error, Group, Label } from '@/Components/UI/Form/Partials';
import { FormInputProps } from '@/types';

type InputProps = FormInputProps<HTMLInputElement>

export const Toggle = ({
                             id,
                             name,
                             label,
                             required = false,
                             disabled = false,
                             groupClassName,
                             ...rest
                         }: InputProps) => {
    const { value, setValue, error } = useFormInput<boolean>(name);

    return (
        <Group className={groupClassName}>
            <div className={'flex items-center gap-2'}>
                <BaseToggle
                    {...rest}
                    id={id ?? name}
                    name={name}
                    checked={Boolean(value ?? false)}
                    onChange={(e) => setValue(Boolean(e.target.checked))}
                    invalid={error !== undefined} />

                <Label
                    htmlFor={id ?? name}
                    className={'mb-0 font-normal'}
                    required={required}
                    disabled={disabled}
                    invalid={error !== undefined}>
                    {label}
                </Label>
            </div>

            <Error error={error} />
        </Group>
    );
};
